import { storeContextManager } from '../context/storeContextManager';
import { createContextManager } from '../context/contextManager';
export function startGlobalContext(hooks, configuration, productKey, useContextNamespace) {
  var globalContextManager = buildGlobalContextManager();
  if (configuration.storeContextsAcrossPages) {
    storeContextManager(configuration, globalContextManager, productKey, 2 /* CustomerDataType.GlobalContext */);
  }
  hooks.register(0 /* HookNames.Assemble */, function () {
    var context = globalContextManager.getContext();
    return useContextNamespace ? {
      context: context
    } : context;
  });
  return globalContextManager;
}
export function buildGlobalContextManager() {
  return createContextManager('global context');
}